import axios from "axios";
import {ErrorNotification} from "./Notification";
import Cookies from 'js-cookie';
import {redirect} from "react-router-dom";

export default async function HttpRequest(url, successResponseFunction, method = 'get', data = [], failResponseFunction) {
    const token = `Bearer ${Cookies.get('access_token')}`
    const headers = {Authorization: token, timeout: 5000}
    await axios({url, data, method, headers}).then(successResponseFunction).catch((error) => {
        if (failResponseFunction) {
            failResponseFunction(error)
        } else {
            let status = error.response.status;
            switch (status) {
                case 403:
                case 404:
                    ErrorNotification(error.response.data.message);
                    break;
                case 429:
                    ErrorNotification('تعداد درخواست ها از حد مجاز بیشتر است.لطفا بعدا اقدام نمائید');
                    break;
                case 422:
                    const errors = error.response.data.errors
                    // eslint-disable-next-line array-callback-return
                    Object.keys(errors).map(err => {
                        ErrorNotification(errors[err]);
                    })
                    break;
                default:
                    ErrorNotification('متاسفانه خطایی رخ داده است.لطفا بعدا اقدام نمائید');
                    break;
            }
        }
    })
}